/**
 * Obergrenzen für salon-konfigurierbare Freitexte.
 *
 * Spiegelt `TimeGlobe_backend/app/constants/content_limits.py` — beide Seiten
 * müssen dieselben Zahlen kennen: das Backend weist ab, das Frontend erklärt
 * vorher, damit niemand erst einen langen Text tippt und dann eine Fehlermeldung
 * kassiert. Wer hier etwas ändert, ändert es auch dort.
 *
 * Hintergrund: jedes Zeichen wandert in den System-Prompt und liegt bei einem
 * Anruf in jedem Turn im Kontext. Kurz ist billiger — und der Agent hält sich
 * an ein paar klare Sätze zuverlässiger als an drei Seiten Fließtext.
 */

// Freie Anweisungen
// 30.08.2026 von 7 auf 10 angehoben: ein Salon lag mit 7 Regeln knapp über dem
// Zeichenbudget, wodurch dauerhaft und unbemerkt eine Regel aus dem Prompt fiel.
export const AGENT_RULE_TEXT_MAX = 700;
export const AGENT_RULE_TITLE_MAX = 120;
export const AGENT_RULES_MAX_ACTIVE = 10;

// Cross-Selling
export const ADDON_NOTE_MAX = 300;

// Telefon-Agent
export const VOICE_GREETING_MAX = 300;
export const VOICE_FAREWELL_MAX = 300;
export const AGENT_NAME_MAX = 40;

// WhatsApp-Agent
export const WHATSAPP_GREETING_MAX = 500;

// Budget-Ansagen
export const BUDGET_MESSAGE_MAX = 500;

// Support-Tickets: Grenzen kommen aus GET /support-tickets/config
// (SupportTicketConfig.limits) — bewusst keine Kopie hier.

/** Ab wann der Zähler warnt (90 % ausgeschöpft). */
export const COUNTER_WARN_RATIO = 0.9;
